import ThermoScientific from '@/assets/images/cart/thermofisher-scientific.svg';
import ALF from '@/assets/images/cart/alfa-aesar.svg';
import ACR from '@/assets/images/cart/acros-organics.svg';
import FISH from '@/assets/images/cart/fish.png';

export const gridClassName =
  'grid grid-cols-[30px_100px_minmax(250px,_1fr)_minmax(80px,_1fr)_120px_minmax(170px,_1fr)] print:grid-cols-[30px_120px_minmax(250px,_1fr)_minmax(80px,_1fr)_60px_150px] gap-x-2 lg:grid-cols-[30px_100px_minmax(250px,_1fr)_120px_minmax(170px,_1fr)] md:grid-cols-[30px_100px_minmax(250px,_1fr)_120px_minmax(170px,_1fr)] sm:grid-cols-[30px_1fr]';

export const brandLogo = {
  'Thermo Scientific&trade;': ThermoScientific,
  ALF: ALF,
  ACR: ACR,
  FISH: FISH,
};

export const QUICK_ADD_ERROR_MESSAGE_MAP = {
  '534': 'sku.not.available',
  '535': 'sku.not.available.online',
  '536': 'sku.discontinued',
  '537': 'sku.contact.us',
  '539': 'sku.not.entitlement',
  '566': 'sku.not.order',
};
